import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MLIcon from '../../../MLIcon/MLIcon';
import s from './Sorter.module.css';
import MLButton from '../../../MLButton/MLButton';
import { GRADEBOOK_SORT } from '../../../../utils/constants';

class Sorter extends PureComponent {
  static propTypes = {
    handleSort: PropTypes.func,
    active: PropTypes.bool,
    ariaSettings: PropTypes.shape({
      key: PropTypes.string,
      description: PropTypes.string,
    }),
  };

  constructor() {
    super();
    this.state = {
      order: GRADEBOOK_SORT.LODASH_ASCENDING,
    };
  }

  render() {
    const { active, handleSort, ariaSettings } = this.props;
    const searchParams = new URLSearchParams(window.location.search);
    const order = searchParams.get('iconSortDirection') || this.state.order;
    const { LODASH_ASCENDING, LODASH_DESCENDING } = GRADEBOOK_SORT;

    let type;
    if (active) {
      type =
        order === LODASH_ASCENDING ? 'sorter_caret_up' : 'sorter_caret_down';
    } else {
      type = 'sorter_caret_up_down';
    }

    // Determine aria-sort value based on active state and sort order
    let ariaSortValue = 'none';
    if (active) {
      ariaSortValue = order === LODASH_ASCENDING ? 'ascending' : 'descending';
    }

    // Create descriptive aria-label that conveys current state and next action
    let ariaLabel;
    if (!active) {
      ariaLabel = `Sort ${ariaSettings.description} column`;
    } else if (order === LODASH_ASCENDING) {
      ariaLabel = `${ariaSettings.description} column sorted ascending. Click to sort descending`;
    } else {
      ariaLabel = `${ariaSettings.description} column sorted descending. Click to sort ascending`;
    }

    const customAttribs = [
      { attribute: 'aria-label', value: ariaLabel },
      { attribute: 'aria-sort', value: ariaSortValue },
      { attribute: 'tabIndex', value: 0 },
    ];

    return (
      <MLButton
        btnType="secondary"
        className={`${s.button} ${active ? s.active : ''}`}
        testId={`gradebook-sort-${ariaSettings.key}`}
        onClick={() => {
          if (order === LODASH_ASCENDING) {
            this.setState({ order: LODASH_DESCENDING });
            handleSort(LODASH_DESCENDING);
          } else {
            this.setState({ order: LODASH_ASCENDING });
            handleSort(LODASH_ASCENDING);
          }
        }}
        customAttributes={customAttribs}
      >
        <MLIcon
          width={18}
          height={18}
          viewBox="0 0 18 18"
          type={type}
          className={s.headerBtnIcon}
        />
      </MLButton>
    );
  }
}

export default Sorter;
